import { createContext } from 'react';

import { SourceEnum } from 'js/src/client';
import { EDITOR_TAB_OPTIONS } from 'js/src/data/app';
import { SEARCH_CONTEXT } from 'js/src/data/media';

export type TEditorTabsContext = {
    editorTab: null | EDITOR_TAB_OPTIONS;
};

export const EditorTabsContext = createContext<TEditorTabsContext>({
    editorTab: null,
});

export const EditorTabsContextProvider = EditorTabsContext.Provider;
export const EditorTabsContextConsumer = EditorTabsContext.Consumer;

export function getUploadSourceFromContext(editorTab: EDITOR_TAB_OPTIONS | null) {
    switch (editorTab) {
        case EDITOR_TAB_OPTIONS.VOICEOVER:
            return SourceEnum.SOURCE_USER_VOICEOVER;
        case EDITOR_TAB_OPTIONS.STICKERS:
            return SourceEnum.SOURCE_USER_STICKERS;
        default:
            return SourceEnum.SOURCE_USER;
    }
}

export function getUploadSearchContextFromEditorTabContext(editorTab: EDITOR_TAB_OPTIONS | null) {
    switch (editorTab) {
        case EDITOR_TAB_OPTIONS.MEDIA:
            return SEARCH_CONTEXT.UPLOADED_VISUALS;
        case EDITOR_TAB_OPTIONS.MUSIC:
            return SEARCH_CONTEXT.UPLOADED_AUDIO;
        case EDITOR_TAB_OPTIONS.ICONS:
            return SEARCH_CONTEXT.UPLOADED_ICONS;
        case EDITOR_TAB_OPTIONS.STICKERS:
            return SEARCH_CONTEXT.UPLOADED_STICKERS;
        case EDITOR_TAB_OPTIONS.VOICEOVER:
            return SEARCH_CONTEXT.UPLOADED_VOICEOVERS;
        default:
            throw Error('Editor tab does not support upload');
    }
}
